import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Alert from "react-bootstrap/Alert";
import "./styles.css";

class Welcome extends React.Component {
  render() {
    return ["light"].map((variant, idx) => (
      <Alert key={idx} variant={variant}>
        We’ve been building guitars since forever - now it’s your turn.
      </Alert>
    ));
  }
}

// Exporting the component
export default Welcome;
